var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoostopiaLogo3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 973,
    height: 213,
    viewBox: "0 0 973 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246.917 166.684H288.618C314.147 166.684 327.783 153.206 327.783 133.069C327.783 115.628 317.001 106.748 306.536 103.735C312.878 100.723 320.489 93.429 320.489 81.3784C320.489 65.8395 307.963 54.106 289.411 54.106H246.917V166.684ZM271.97 144.803V116.262H286.716C297.974 116.262 302.889 122.129 302.889 130.532C302.889 139.253 297.974 144.803 287.033 144.803H271.97ZM271.97 96.9174V75.9873H284.02C292.107 75.9873 296.388 79.6342 296.388 86.2938C296.388 92.4777 292.582 96.9174 284.496 96.9174H271.97Z",
    fill: "url(#paint0_linear_4529_584)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.313 168.27C400.877 168.27 423.076 153.524 423.076 125.458C423.076 97.3931 400.877 82.6469 379.313 82.6469C357.749 82.6469 335.55 97.3931 335.55 125.458C335.55 153.524 357.749 168.27 379.313 168.27ZM359.81 125.458C359.81 112.773 368.689 104.845 379.313 104.845C389.936 104.845 398.816 112.773 398.816 125.458C398.816 138.143 389.936 146.071 379.313 146.071C368.689 146.071 359.81 138.143 359.81 125.458Z",
    fill: "url(#paint1_linear_4529_584)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M473.768 168.27C495.332 168.27 517.531 153.524 517.531 125.458C517.531 97.3931 495.332 82.6469 473.768 82.6469C452.204 82.6469 430.005 97.3931 430.005 125.458C430.005 153.524 452.204 168.27 473.768 168.27ZM454.265 125.458C454.265 112.773 463.144 104.845 473.768 104.845C484.392 104.845 493.271 112.773 493.271 125.458C493.271 138.143 484.392 146.071 473.768 146.071C463.144 146.071 454.265 138.143 454.265 125.458Z",
    fill: "url(#paint2_linear_4529_584)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M553.057 168.27C571.45 168.27 585.562 158.915 585.562 142.266C585.562 127.361 573.828 121.177 564.949 118.165L554.643 114.359C549.093 112.615 547.507 110.078 547.507 107.382C547.507 104.528 549.886 101.674 554.643 101.674C557.972 101.674 562.095 103.101 564.156 109.444L583.342 104.687C580.488 91.3677 569.23 82.6469 553.691 82.6469C537.518 82.6469 523.723 91.6849 523.723 107.065C523.723 117.372 529.59 126.251 543.226 131.167L554.326 135.289C559.717 137.033 561.302 139.57 561.302 142.266C561.302 146.864 557.18 149.084 552.74 149.084C544.97 149.084 542.116 143.534 540.848 139.57L521.345 144.803C523.882 160.5 536.408 168.27 553.057 168.27Z",
    fill: "url(#paint3_linear_4529_584)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M629.574 167.635C635.282 167.635 642.259 166.526 645.43 163.354V144.644C642.417 145.596 639.563 145.913 637.66 145.913C630.208 145.913 627.83 141.473 627.83 137.35V103.735H645.113V84.2325H627.83V63.1439H603.253V84.2325H591.043V103.735H603.253V141.314C603.253 160.183 614.352 167.635 629.574 167.635Z",
    fill: "url(#paint4_linear_4529_584)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M695.815 168.27C717.379 168.27 739.578 153.524 739.578 125.458C739.578 97.3931 717.379 82.6469 695.815 82.6469C674.251 82.6469 652.052 97.3931 652.052 125.458C652.052 153.524 674.251 168.27 695.815 168.27ZM676.312 125.458C676.312 112.773 685.191 104.845 695.815 104.845C706.439 104.845 715.318 112.773 715.318 125.458C715.318 138.143 706.439 146.071 695.815 146.071C685.191 146.071 676.312 138.143 676.312 125.458Z",
    fill: "url(#paint5_linear_4529_584)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M748.923 196.811H773.5V157.329H773.976C775.244 160.342 783.806 168.27 798.394 168.27C817.104 168.27 837.717 154.158 837.717 125.458C837.717 96.7588 817.104 82.6469 798.394 82.6469C783.806 82.6469 775.244 90.5749 773.976 93.5876H773.5V84.2325H748.923V196.811ZM772.866 125.458C772.866 111.981 782.538 104.528 793.32 104.528C803.785 104.528 813.457 112.139 813.457 125.458C813.457 138.777 803.785 146.388 793.32 146.388C782.538 146.388 772.866 138.936 772.866 125.458Z",
    fill: "url(#paint6_linear_4529_584)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M848.643 166.684H873.22V84.2325H848.643V166.684ZM848.643 75.5117H873.22V54.106H848.643V75.5117Z",
    fill: "url(#paint7_linear_4529_584)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M923.487 168.27C938.075 168.27 946.637 160.342 947.906 157.329H948.381V166.684H972.958V84.2325H948.381V93.5876H947.906C946.637 90.5749 938.075 82.6469 923.487 82.6469C904.777 82.6469 884.164 96.7588 884.164 125.458C884.164 154.158 904.777 168.27 923.487 168.27ZM908.424 125.458C908.424 112.139 918.096 104.528 928.561 104.528C939.343 104.528 949.016 111.981 949.016 125.458C949.016 138.936 939.343 146.388 928.561 146.388C918.096 146.388 908.424 138.777 908.424 125.458Z",
    fill: "url(#paint8_linear_4529_584)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 106.5,
    fill: "#FFD956"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 106.5,
    fill: "#FFD956"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7661 134.22L97.2639 144.718C175.892 98.5688 160.82 52.8197 160.82 52.8197C160.82 52.8197 115.032 37.7471 68.9217 116.376L79.4195 126.873",
    fill: "#171630"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7661 134.22L97.2639 144.718C175.892 98.5688 160.82 52.8197 160.82 52.8197C160.82 52.8197 115.032 37.7471 68.9217 116.376L79.4195 126.873",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5212 145.118C66.4913 143.088 66.4776 139.815 68.4908 137.802L108.025 98.2674C108.332 97.9607 108.736 97.7891 109.178 97.7716L116.235 95.6639C117.236 95.6296 118.048 96.4416 118.014 97.4426L115.906 104.5C115.889 104.942 115.717 105.346 115.41 105.653L75.876 145.187C73.8242 147.162 70.5512 147.148 68.5212 145.118Z",
    fill: "#FFD956",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M108.172 68.6963L88.4159 67.8826C88.4159 67.8826 60.2177 78.7971 54.9432 106.768C54.9432 106.768 67.3858 94.1712 78.7537 100.938",
    fill: "#171630"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M108.172 68.6963L88.4159 67.8826C88.4159 67.8826 60.2177 78.7971 54.9432 106.768C54.9432 106.768 67.3858 94.1712 78.7537 100.938",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M144.944 105.467L145.757 125.224C145.757 125.224 134.843 153.422 106.871 158.697C106.871 158.697 119.469 146.254 112.702 134.886",
    fill: "#171630"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M144.944 105.467L145.757 125.224C145.757 125.224 134.843 153.422 106.871 158.697C106.871 158.697 119.469 146.254 112.702 134.886",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M123.888 88.8229C128.832 93.7665 136.814 93.7997 141.717 88.897C146.619 83.9944 146.586 76.0124 141.643 71.0688C136.699 66.1252 128.717 66.0921 123.814 70.9947C118.912 75.8974 118.945 83.8793 123.888 88.8229Z",
    fill: "#FFD956",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8662 120.32L66.2707 126.915L72.8246 133.469",
    fill: "#171630"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8662 120.32L66.2707 126.915L72.8246 133.469",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70 126L72.1752 128.224L76.4958 123.999",
    fill: "#171630"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70 126L72.1752 128.224L76.4958 123.999",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84 140.225L86.1752 142.45L90.4958 138.224",
    fill: "#171630"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84 140.225L86.1752 142.45L90.4958 138.224",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3205 140.774L86.725 147.369L80.1711 140.815",
    fill: "#171630"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3205 140.774L86.725 147.369L80.1711 140.815",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3545 134.427L51.0425 145.739",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8984 150.869L50.5169 158.251",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4639 151.536L68.1519 162.848",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0078 156.979L56.6262 164.36",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4529_584",
    x1: 151.063,
    y1: 75.7665,
    x2: 801.528,
    y2: 471.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEE6"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoostopiaLogo3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/boostopia-logo-3.7cf764269973a39aebf02077b8594a64.svg";